import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = { class: "table-header-item-count" }
const _hoisted_2 = { class: "pb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_TableHeader = _resolveComponent("TableHeader")!
  const _component_TextHighlights = _resolveComponent("TextHighlights")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _component_v_infinite_scroll = _resolveComponent("v-infinite-scroll")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_UploadDialog = _resolveComponent("UploadDialog")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_NowhowDatepicker = _resolveComponent("NowhowDatepicker")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_SingleFilter = _resolveComponent("SingleFilter")!
  const _component_FilterDrawer = _resolveComponent("FilterDrawer")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_infinite_scroll, { onLoad: _ctx.load }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_data_table_server, {
                    "sort-by": _ctx.sortBy,
                    "onUpdate:sortBy": [
                      _cache[3] || (_cache[3] = ($event: any) => ((_ctx.sortBy) = $event)),
                      _ctx.onSortByChanged
                    ],
                    headers: _ctx.headers,
                    items: _ctx.fehlerhafteRechnungenList,
                    "item-value": "tvsLieferantRechnungId",
                    loading: _ctx.loading,
                    "hide-default-footer": "",
                    class: "elevation-1",
                    "items-length": _ctx.totalNumberOfRecords || 0,
                    "must-sort": true,
                    "custom-sort": _ctx.customSort,
                    hover: ""
                  }, {
                    top: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_TableHeader, {
                          filters: _ctx.filters,
                          onChipClosed: _ctx.removeFilter
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.totalNumberOfRecords + ' ' + _ctx.$t('archiv.table.header.items')), 1),
                            (_ctx.showSearchBar)
                              ? (_openBlock(), _createBlock(_component_v_text_field, {
                                  key: 0,
                                  modelValue: _ctx.filterData.suchText,
                                  "onUpdate:modelValue": [
                                    _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterData.suchText) = $event)),
                                    _ctx.searchFieldInputChanged
                                  ],
                                  class: "ml-5",
                                  "prepend-inner-icon": "mdi-magnify",
                                  "append-inner-icon": "mdi-close",
                                  label: _ctx.$t('rechnungen.suchfeld'),
                                  "hide-details": "",
                                  autofocus: "",
                                  "onClick:appendInner": _ctx.searchBarClosed
                                }, null, 8, ["modelValue", "label", "onUpdate:modelValue", "onClick:appendInner"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_spacer),
                            _createVNode(_component_v_tooltip, {
                              top: "",
                              color: "secondary"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_btn, _mergeProps(props, {
                                  icon: "",
                                  color: "primary"
                                }), {
                                  default: _withCtx(() => [
                                    (!_ctx.showSearchBar)
                                      ? (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 0,
                                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSearchBar = !_ctx.showSearchBar))
                                        }, {
                                          default: _withCtx(() => _cache[13] || (_cache[13] = [
                                            _createTextVNode("mdi-magnify")
                                          ])),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1040)
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('tableheader.tooltip.search')), 1)
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_tooltip, {
                              top: "",
                              color: "secondary"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_btn, _mergeProps(props, {
                                  icon: "",
                                  color: "primary",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showFilterDrawer = !_ctx.showFilterDrawer))
                                }), {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => _cache[14] || (_cache[14] = [
                                        _createTextVNode("mdi-filter-outline")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1040)
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('tableheader.tooltip.filter')), 1)
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["filters", "onChipClosed"])
                      ])
                    ]),
                    "item.rechnungNummer": _withCtx(({ item }) => [
                      _createVNode(_component_TextHighlights, {
                        text: item.rechnungNummer,
                        "search-text": _ctx.filterData.suchText
                      }, null, 8, ["text", "search-text"])
                    ]),
                    "item.tvsKundennummer": _withCtx(({ item }) => [
                      _createVNode(_component_TextHighlights, {
                        text: item.tvsKundennummer,
                        "search-text": _ctx.filterData.suchText
                      }, null, 8, ["text", "search-text"])
                    ]),
                    "item.fehlermeldung": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(item && item.fehlermeldung
                                    ? item.fehlermeldung
                                          .split(';')
                                          .map((error) => _ctx.$t(error.trim(), error.trim()))
                                          .join('; ')
                                    : ''), 1)
                    ]),
                    "item.burgermenu": _withCtx(({ item }) => [
                      _createVNode(_component_v_menu, {
                        modelValue: item.burgermenuActive,
                        "onUpdate:modelValue": ($event: any) => ((item.burgermenuActive) = $event),
                        "offset-x": ""
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn, _mergeProps({
                            icon: "",
                            href: item.burgermenu
                          }, props, { class: "elevation-0" }), {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                color: "primary",
                                icon: "mdi-menu"
                              })
                            ]),
                            _: 2
                          }, 1040, ["href"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item, {
                                onClick: ($event: any) => (_ctx.retryRechnungProcessing(item.tvsLieferantRechnungId))
                              }, {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_v_icon, { icon: "mdi-reload" })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, {
                                    textContent: _toDisplayString(_ctx.$t('rechnungen.fehlerhaft.burgermenu.retry'))
                                  }, null, 8, ["textContent"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_v_divider),
                              _createVNode(_component_v_list_item, {
                                disabled: !item.xmlDokumentGuid || item.xmlDokumentGuid === '00000000-0000-0000-0000-000000000000',
                                onClick: ($event: any) => (
                                            _ctx.downloadBeleg({
                                                id: item.xmlDokumentGuid,
                                                defaultFileName: `${item.xmlDokumentGuid}.xml`
                                            })
                                        )
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, {
                                    textContent: _toDisplayString(_ctx.$t('rechnungen.fehlerhaft.burgermenu.downloadxml'))
                                  }, null, 8, ["textContent"])
                                ]),
                                _: 2
                              }, 1032, ["disabled", "onClick"]),
                              _createVNode(_component_v_list_item, {
                                onClick: ($event: any) => (_ctx.openXmlUploadDialog(item.tvsLieferantRechnungId))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, {
                                    textContent: _toDisplayString(_ctx.$t('rechnungen.fehlerhaft.burgermenu.uploadxml'))
                                  }, null, 8, ["textContent"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_v_divider),
                              _createVNode(_component_v_list_item, {
                                disabled: !item.pdfDokumentGuid || item.pdfDokumentGuid === '00000000-0000-0000-0000-000000000000',
                                onClick: ($event: any) => (
                                            item.pdfDokumentGuid &&
                                                _ctx.openDokument({
                                                    id: item.pdfDokumentGuid,
                                                    dateiTyp: 'application/pdf',
                                                    dokumentName: `${item.pdfDokumentGuid}.pdf`
                                                })
                                        )
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, {
                                    textContent: _toDisplayString(_ctx.$t('rechnungen.fehlerhaft.burgermenu.viewpdf'))
                                  }, null, 8, ["textContent"])
                                ]),
                                _: 2
                              }, 1032, ["disabled", "onClick"]),
                              _createVNode(_component_v_list_item, {
                                onClick: ($event: any) => (_ctx.openPdfUploadDialog(item.tvsLieferantRechnungId))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, {
                                    textContent: _toDisplayString(_ctx.$t('rechnungen.fehlerhaft.burgermenu.uploadpdf'))
                                  }, null, 8, ["textContent"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_v_divider),
                              _createVNode(_component_ConfirmDialog, {
                                title: "rechnungen.fehlerhaft.deletedialog.title",
                                text: "rechnungen.fehlerhaft.deletedialog.text",
                                onConfirm: ($event: any) => (_ctx.deleteFehlerhafteRechnung(item.tvsLieferantRechnungId))
                              }, {
                                activatorElement: _withCtx(({ props }) => [
                                  _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                                    prepend: _withCtx(() => [
                                      _createVNode(_component_v_icon, { icon: "mdi-trash-can" })
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, {
                                        textContent: _toDisplayString(_ctx.$t('archiv.table.burgermenu.delete'))
                                      }, null, 8, ["textContent"])
                                    ]),
                                    _: 2
                                  }, 1040)
                                ]),
                                _: 2
                              }, 1032, ["onConfirm"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }, 8, ["sort-by", "headers", "items", "loading", "items-length", "custom-sort", "onUpdate:sortBy"])
                ]),
                _: 1
              }, 8, ["onLoad"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_UploadDialog, {
        ref: "xmlUploadDialog",
        "file-type": "XML",
        "on-upload": _ctx.uploadFehlerhafteRechnungDatei
      }, null, 8, ["on-upload"]),
      _createVNode(_component_UploadDialog, {
        ref: "pdfUploadDialog",
        "file-type": "PDF",
        "on-upload": _ctx.uploadFehlerhafteRechnungDatei
      }, null, 8, ["on-upload"]),
      _createVNode(_component_FilterDrawer, {
        visible: _ctx.showFilterDrawer,
        "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showFilterDrawer) = $event)),
        onCancel: _cache[9] || (_cache[9] = ($event: any) => (_ctx.cancelFilter())),
        onConfirm: _cache[10] || (_cache[10] = ($event: any) => (_ctx.confirmFilter())),
        onClear: _cache[11] || (_cache[11] = ($event: any) => (_ctx.clearAllFilters(true))),
        onReset: _cache[12] || (_cache[12] = ($event: any) => (_ctx.clearAllFilters(false)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SingleFilter, { title: "" }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _createVNode(_component_v_radio_group, {
                    modelValue: _ctx.radios,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.radios) = $event)),
                    class: "mt-0",
                    inline: ""
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.$t('archiv.filter.title.datum')), 1),
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_radio, {
                            value: "specificTime",
                            label: _ctx.$t('rechnungen.filter.label.specifictime')
                          }, null, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        class: "pt-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "6" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_NowhowDatepicker, {
                                    modelValue: _ctx.filterData.rechnungDatumVon,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterData.rechnungDatumVon) = $event)),
                                    disabled: _ctx.radios !== 'specificTime',
                                    label: _ctx.$t('archiv.filter.datum.von'),
                                    onChange: _ctx.onRechnungsDatumVonChange
                                  }, null, 8, ["modelValue", "disabled", "label", "onChange"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, { cols: "6" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_NowhowDatepicker, {
                                    modelValue: _ctx.filterData.rechnungDatumBis,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filterData.rechnungDatumBis) = $event)),
                                    disabled: _ctx.radios !== 'specificTime',
                                    label: _ctx.$t('archiv.filter.datum.bis'),
                                    onChange: _ctx.onRechnungsDatumBisChange
                                  }, null, 8, ["modelValue", "disabled", "label", "onChange"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        class: "pt-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_radio, {
                            value: "selectTime",
                            label: _ctx.$t('rechnungen.filter.label.selecttime')
                          }, null, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        class: "pt-0 pb-8"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            modelValue: _ctx.filterData.zeitspanne,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filterData.zeitspanne) = $event)),
                            disabled: _ctx.radios !== 'selectTime',
                            variant: "filled",
                            density: "compact",
                            "hide-details": "",
                            items: _ctx.ddTimeItems
                          }, null, 8, ["modelValue", "disabled", "items"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        class: "pt-0 pb-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_radio, {
                            value: "allTime",
                            label: _ctx.$t('kontobrowser.filter.alltime')
                          }, null, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _: 1
  }))
}